import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const Region = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string()
});

export type Region = z.infer<typeof Region>;

export default c.router({
  getRegions: {
    method: 'GET',
    path: '/regions',
    responses: {
      200: z.object({
        items: z.array(Region)
      }),
      ...failedResponses
    }
  }
});
